import { setValuationInfo } from './reducer';
import { SET_VALUATION_INFO } from '../../actions/valuations/types';

export default {
  [SET_VALUATION_INFO]: setValuationInfo,
};
